import * as React from 'react';
import { Box, Button, Typography } from '@mui/material';

export const GdprBanner: React.FC = () => {
  const [accepted, setAccepted] = React.useState(() =>
    localStorage.getItem('gdprAccepted') === 'true'
  );

  if (accepted) return null;

  return (
    <Box
      sx={{
        position:    'fixed',
        bottom:      0,
        left:        0,
        right:       0,
        bgcolor:     'background.paper',
        boxShadow:   3,
        p:           2,
        display:     'flex',
        alignItems:  'center',
        justifyContent: 'space-between',
        zIndex:      theme => theme.zIndex.snackbar,
      }}
    >
      <Typography variant="body2">
        Ce site utilise des cookies pour améliorer votre expérience. En continuant, vous acceptez notre politique de confidentialité.
      </Typography>
      <Button
        variant="outlined"
        onClick={() => {
          localStorage.setItem('gdprAccepted', 'true');
          setAccepted(true);
        }}
        size="small"
      >
        Accepter
      </Button>
    </Box>
  );
};
